var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_249_1598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.5 33.333C81.4583 33.333 78.0833 39.333 79.4583 43.7913L64.6666 58.6247C63.4166 58.2497 61.5833 58.2497 60.3333 58.6247L49.7083 47.9997C51.125 43.5413 47.75 37.4997 41.6666 37.4997C35.625 37.4997 32.2083 43.4997 33.625 47.9997L14.625 66.958C10.1666 65.583 4.16663 68.958 4.16663 74.9997C4.16663 79.583 7.91663 83.333 12.5 83.333C18.5416 83.333 21.9166 77.333 20.5416 72.8747L39.5 53.8747C40.75 54.2497 42.5833 54.2497 43.8333 53.8747L54.4583 64.4997C53.0416 68.958 56.4166 74.9997 62.5 74.9997C68.5416 74.9997 71.9583 68.9997 70.5416 64.4997L85.375 49.708C89.8333 51.083 95.8333 47.708 95.8333 41.6663C95.8333 37.083 92.0833 33.333 87.5 33.333Z",
    fill: "#F84343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.596 35.466C61.9464 36.2543 63.0636 36.2588 63.4203 35.4733L66.2609 29.218C66.3613 28.9969 66.5387 28.8199 66.76 28.72L72.9811 25.9114C73.7659 25.5572 73.7659 24.4428 72.9811 24.0886L66.76 21.28C66.5387 21.1801 66.3613 21.0031 66.2609 20.782L63.4203 14.5267C63.0636 13.7412 61.9464 13.7457 61.596 14.534L58.8224 20.7747C58.7221 21.0002 58.542 21.1807 58.3167 21.2815L52.0418 24.0871C51.2527 24.4399 51.2527 25.5601 52.0418 25.9129L58.3167 28.7185C58.542 28.8193 58.7221 28.9998 58.8224 29.2253L61.596 35.466Z",
    fill: "#F84343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6132 41.9528C13.8656 42.9627 15.3009 42.9627 15.5534 41.9528L16.5211 38.0821C16.6107 37.7238 16.8904 37.4441 17.2487 37.3545L21.1194 36.3868C22.1293 36.1343 22.1293 34.699 21.1194 34.4465L17.2487 33.4789C16.8904 33.3893 16.6107 33.1095 16.5211 32.7512L15.5534 28.8806C15.3009 27.8706 13.8656 27.8706 13.6132 28.8806L12.6455 32.7512C12.5559 33.1095 12.2762 33.3893 11.9179 33.4789L8.0472 34.4465C7.03724 34.699 7.03724 36.1343 8.0472 36.3868L11.9179 37.3545C12.2762 37.4441 12.5559 37.7238 12.6455 38.0821L13.6132 41.9528Z",
    fill: "#F84343"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_249_1598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.052b1feb10f4b37d23ad0f0c6b244bf3.svg";
export { ForwardRef as ReactComponent };